import { updateUserNotifications } from '@/fetchers/umsAPI/user.fetchers';
import { useGaEventBaseParams, useGlobalState } from '@/hooks';
import { useState } from 'react';

export const useNotification = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [isToggling, setIsToggling] = useState(false);
  const { userInfo, setUserInfo } = useGlobalState();
  const getGaEventBaseParams = useGaEventBaseParams();

  const handleToggleNotification = async (payload: {
    subscribeToEmailSummary?: boolean;
    defaultOptIn?: boolean;
    newsletterOptIn?: boolean;
  }) => {
    setIsToggling(true);
    setShowDialog(false);

    if (!userInfo) {
      console.error('User info is not available');
      return;
    }

    try {
      const gaEventBaseParams = getGaEventBaseParams();
      const res = await updateUserNotifications({
        ...payload,
        ...gaEventBaseParams,
      });

      if (res.data) {
        setUserInfo({
          ...userInfo,
          subscribeToEmailSummary: res.data.subscribe_to_email_summary,
          defaultOptIn: res.data.default_opt_in,
          newsletterOptIn: res.data.newsletter_opt_in,
        });

        // TODO: [p4] update GA4 event later
        // gtmResubSummaryToggle();
      }
    } catch (err) {
      console.error('Error updating email summary subscription', err);
    } finally {
      setIsToggling(false);
    }
  };

  return {
    showDialog,
    setShowDialog,
    isToggling,
    handleToggleNotification,
  };
};
